'use strict';
import Promise from 'bluebird';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
import {combineEpics, createEpicMiddleware} from 'redux-observable';
import {onChangeLanguage} from '../../_libs/angular-translate-redux';
import {epics as appEpics} from '../../app/epics';
import {epics as assetsEpics} from '../../assets/epics';
import {epics as authEpics} from '../../auth/epics';
import {epics as chatEpics} from '../../comments/epics';
import {epics as coreComponentsEpics} from '../../core-components/epics';
import {epics as coreUtilitiesEpics} from '../../core-utilities/epics';
import {epics as formsEpics} from '../../forms/epics';
import {epics as milestonesEpics} from '../../milestones/epics';
import {epics as organizationsEpics} from '../../organizations/epics';
import {epics as personnelEpics} from '../../personnel/epics';
import {epics as prioritiesEpics} from '../../priorities/epics';
import {epics as projectsEpics} from '../../projects/epics';
import {epics as requirementsEpics} from '../../requirements/epics';
import {epics as settingsEpics} from '../../settings/epics';
import {epics as systemEpics} from '../../system/epics';
import {epics as tasksEpics} from '../../tasks/epics';
import {epics as timersEpics} from '../../timers/epics';
import {epics as todoMessagesEpics} from '../../todo-messages/epics';
import {userEpics} from '../../user/epics';
import {epics as userProfileEpics} from '../../user-profile/epics';


onChangeLanguage.$inject = ['$translate'];

const epics = [
  onChangeLanguage,
  ...appEpics,
  ...assetsEpics,
  ...authEpics,
  ...chatEpics,
  ...coreComponentsEpics,
  ...coreUtilitiesEpics,
  ...formsEpics,
  ...milestonesEpics,
  ...organizationsEpics,
  ...personnelEpics,
  ...prioritiesEpics,
  ...projectsEpics,
  ...requirementsEpics,
  ...settingsEpics,
  ...systemEpics,
  ...tasksEpics,
  ...timersEpics,
  ...todoMessagesEpics,
  ...userEpics,
  ...userProfileEpics,
];

const rootEpic = combineEpics(
  ...epics,
);

const $$injected = Promise.defer();

// collect service name keys and eliminate duplicates
const $inject = epics.reduce((acc, f) => {
  if (f.$inject) {
    if (!isArray(f.$inject)) {
      throw new Error(`Expected epic $inject to be an array of strings. Received invalid $inject.`, f.$inject);
    }

    f.$inject.forEach(dep => {
      if (!isString(dep)) {
        throw new Error(`Expected epic $inject to be an array of strings. Received invalid $inject element.`, dep);
      }

      acc[dep] = true;
    });
  }

  return acc;
}, {});

EpicMiddlewareInjector.$inject = ['$injector'];

const dependencies = {
  $$injected: $$injected.promise,
};

/**
 * Inject the dependencies into the epic middle ware after all services have been initialized.
 * @param $injector
 * @constructor
 */
export function EpicMiddlewareInjector($injector) {
  Object.keys($inject).forEach(serviceName => {
    dependencies[serviceName] = $injector.get(serviceName);
  });
  $$injected.resolve();
}

export const epicMiddleware = createEpicMiddleware(rootEpic, {
  dependencies,
});



// WEBPACK FOOTER //
// ./src/js/config/epics/index.js